
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"50","height":"50","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"filter":"url(#filter0_d_2507_1660)"}},[_c('circle',{attrs:{"cx":"25","cy":"23","r":"19","fill":"#0053FF"}})]),_c('path',{attrs:{"d":"M22.5 15h-3.938a.562.562 0 00-.562.563v15.75a.562.562 0 00.563.562H22.5a.562.562 0 00.563-.563v-15.75A.562.562 0 0022.5 15zM32.313 15h-3.938a.562.562 0 00-.563.563v15.75a.562.562 0 00.563.562h3.938a.562.562 0 00.562-.563v-15.75a.562.562 0 00-.563-.562z","fill":"#fff"}}),_c('defs',[_c('filter',{attrs:{"id":"filter0_d_2507_1660","x":"0","y":"0","width":"50","height":"50","filterUnits":"userSpaceOnUse","color-interpolation-filters":"sRGB"}},[_c('feFlood',{attrs:{"flood-opacity":"0","result":"BackgroundImageFix"}}),_c('feColorMatrix',{attrs:{"in":"SourceAlpha","values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0","result":"hardAlpha"}}),_c('feOffset',{attrs:{"dy":"2"}}),_c('feGaussianBlur',{attrs:{"stdDeviation":"3"}}),_c('feComposite',{attrs:{"in2":"hardAlpha","operator":"out"}}),_c('feColorMatrix',{attrs:{"values":"0 0 0 0 0.167222 0 0 0 0 0.193667 0 0 0 0 0.233333 0 0 0 0.17 0"}}),_c('feBlend',{attrs:{"in2":"BackgroundImageFix","result":"effect1_dropShadow_2507_1660"}}),_c('feBlend',{attrs:{"in":"SourceGraphic","in2":"effect1_dropShadow_2507_1660","result":"shape"}})])])])
          )
        }
      }
    